import { httpClient } from './httpClient';

export interface Department {
    id: number;
    name: string;
    description?: string;
    manager_id?: number;
    manager_name?: string;
    manager_email?: string;
    member_ids?: number[];
    created_at: string;
    updated_at: string;
}

class DepartmentService {
    async getAllDepartments(): Promise<Department[]> {
        const response = await httpClient.get<Department[]>('/api/departments');
        return response;
    }

    async getDepartmentById(id: number): Promise<Department> {
        const response = await httpClient.get<Department>(`/api/departments/${id}`);
        return response;
    }

    async createDepartment(data: { name: string; description?: string; manager_id?: number; member_ids?: number[] }): Promise<Department> {
        const response = await httpClient.post<Department>('/api/departments', data);
        return response;
    }

    async updateDepartment(id: number, data: { name?: string; description?: string; manager_id?: number; member_ids?: number[] }): Promise<Department> {
        const response = await httpClient.put<Department>(`/api/departments/${id}`, data);
        return response;
    }

    async deleteDepartment(id: number): Promise<void> {
        await httpClient.delete(`/api/departments/${id}`);
    }
}

export const departmentService = new DepartmentService();
